import React from "react";
import { motion } from "framer-motion";
import { FaArrowRight, FaGlobe, FaGooglePlay, FaUserShield } from "react-icons/fa";
import pages from "../../data/pages.json";
import karakaaraShot from "../../assets/images/work/karakaara-website.webp";
import "./Work.css";

const screenshots = { karakaara: karakaaraShot };
const builtIcons = [FaGlobe, FaGooglePlay, FaUserShield];

const Work = () => (
  <section id="work" className="lk-section">
    <div className="lk-container">
      <div className="lk-eyebrow">Recent work</div>
      {pages.work.map((project) => (
        <motion.article
          key={project.id}
          className="lk-work"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="lk-work-copy">
            <h2 className="lk-h2 lk-work-title">{project.headline}</h2>
            <p className="lk-lead">{project.summary}</p>

            <h3 className="lk-work-label">What we built</h3>
            <ul className="lk-work-built">
              {project.built.map((item, i) => {
                const Icon = builtIcons[i];
                return (
                  <li key={item.title}>
                    <span className="lk-icon-tile"><Icon aria-hidden="true" /></span>
                    <div>
                      <strong>{item.title}</strong>
                      <p>{item.text}</p>
                    </div>
                  </li>
                );
              })}
            </ul>

            <div className="lk-hero-actions">
              <a href={project.url} className="lk-btn lk-btn-primary" target="_blank" rel="noopener noreferrer">
                Visit {project.domain}
                <FaArrowRight aria-hidden="true" />
              </a>
              <a href={project.playUrl} className="lk-btn lk-btn-ghost" target="_blank" rel="noopener noreferrer">
                <FaGooglePlay aria-hidden="true" />
                Android app
              </a>
            </div>
          </div>

          <a
            className="lk-work-shot"
            href={project.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open ${project.domain}`}
          >
            <div className="lk-work-bar" aria-hidden="true">
              <span />
              <span />
              <span />
              <em>{project.domain}</em>
            </div>
            <img
              src={screenshots[project.id]}
              alt={`${project.name} website homepage`}
              width="1200"
              height="750"
              loading="lazy"
            />
          </a>
        </motion.article>
      ))}
    </div>
  </section>
);

export default Work;
